import {AssistantEvenCompactModel} from "../assistants";
import {APIMethodEnum, ListModel} from "../common";

import {CustomActionQueryParams, LLMVariableType} from "@/api/services";
import {EditCustomActionData} from "@/utils/customAction/schema";
import {BaseAction} from "@/types/api";
import {ActionNodeData} from "@/types/node";

export interface CustomActionRecordModel extends BaseAction {
  title: string;
  description: string;
  type: AuthorizationTypeEnum;
  apiUrl: string;
  apiMethod: APIMethodEnum;
  apiHeaders: {key: string; value: string}[];
  isAuthorizationNeeded: boolean;
  parameters: Record<string, string>;
  assistants: AssistantEvenCompactModel[];
  authLocation?: string;
  authKey?: string;
  authValue?: string;
  speech?: string;
  llm_vars: {
    key?: string;
    description?: string;
    type?: LLMVariableType;
    example?: string;
  }[];
  variablesBeforeTheCall: {
    key?: string;
    value?: string;
  }[];
  queryParameters: {
    key?: string;
    value?: string;
  }[];
  query_params: CustomActionQueryParams;
  body: string;
  isSpeakingNaturally: boolean;
  startMessage: string;
  delayMessage: string;
  failureMessage: string;
  delayMessageTime: string;
  failure_timeout?: number;
  run_action_before_call_start: boolean;
  api_response: {[key: string]: unknown};
  variables: string[];
  nodeData: ActionNodeData;
}

export type CustomActionListModel = ListModel<CustomActionRecordModel>;

export type CustomActionTemplateModel = {
  id: string;
  type: AuthorizationTypeEnum;
  title: string;
  description: string;
  apiMethod: APIMethodEnum;
  apiUrl: string;
};

export type CustomActionTemplateListModel =
  ListModel<CustomActionTemplateModel>;

export enum AuthorizationTypeEnum {
  Custom = "custom",
  GoHighLevel = "ghl",
  Hubspot = "hubspot",
  Salesforce = "salesforce",
}

export type CustomActionResultRecordModel = {
  id: string;
  name: string;
};

export type CustomActionResultListModel =
  ListModel<CustomActionResultRecordModel>;

export enum CustomActionTriggerTypeEnum {
  Before = "Before",
  During = "During",
}

export type CustomActionCreateModel = EditCustomActionData & {
  workspaceId: string;
};

export type CustomActionUpdateModel = EditCustomActionData & {id: string};

export type CustomActionTemplateSummaryResponseModel = {[key: string]: unknown};

export interface CustomActionTemplateDetailsModel {
  title?: string;
  type?: AuthorizationTypeEnum;
  description?: string;
  url?: string;
  httpMethod?: APIMethodEnum;
  installationCount?: number;
  response?: CustomActionTemplateSummaryResponseModel;
  prompt?: string;
}
